// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-features-js": require("gatsby-module-loader?name=component---src-pages-features-js!/opt/build/repo/src/pages/features.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-plans-js": require("gatsby-module-loader?name=component---src-pages-plans-js!/opt/build/repo/src/pages/plans.js"),
  "component---src-pages-privacy-js": require("gatsby-module-loader?name=component---src-pages-privacy-js!/opt/build/repo/src/pages/privacy.js"),
  "component---src-pages-terms-js": require("gatsby-module-loader?name=component---src-pages-terms-js!/opt/build/repo/src/pages/terms.js"),
  "component---src-pages-faq-accessibility-js": require("gatsby-module-loader?name=component---src-pages-faq-accessibility-js!/opt/build/repo/src/pages/faq/accessibility.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "features.json": require("gatsby-module-loader?name=path---features!/opt/build/repo/.cache/json/features.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "plans.json": require("gatsby-module-loader?name=path---plans!/opt/build/repo/.cache/json/plans.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "privacy.json": require("gatsby-module-loader?name=path---privacy!/opt/build/repo/.cache/json/privacy.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "terms.json": require("gatsby-module-loader?name=path---terms!/opt/build/repo/.cache/json/terms.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "faq-accessibility.json": require("gatsby-module-loader?name=path---faq-accessibility!/opt/build/repo/.cache/json/faq-accessibility.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js